import { Mountain } from "lucide-react";
import { LogoMark } from "./Logo";

// Static storefront browser artwork for the Website Creation page.
export const BrowserArt = () => (
  <div
    data-testid="website-hero-artwork"
    aria-hidden="true"
    className="relative mx-auto w-full max-w-[520px] select-none"
  >
    <div className="absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-lilac/[0.14] blur-3xl" />
    <div className="relative rotate-1 rounded-2xl border border-white/10 bg-card shadow-[0_40px_80px_-30px_rgba(0,0,0,0.7)]">
      <div className="flex items-center justify-between border-b border-white/[0.07] px-5 py-3">
        <div className="flex gap-1.5">
          <span className="h-2 w-2 rounded-full bg-white/20" />
          <span className="h-2 w-2 rounded-full bg-white/20" />
          <span className="h-2 w-2 rounded-full bg-white/20" />
        </div>
        <div className="h-2 w-24 rounded-full bg-white/10" />
      </div>
      <div className="space-y-4 p-5 sm:p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <LogoMark className="h-4 w-4 text-paper" />
            <span className="font-display text-xs font-extrabold tracking-wide text-paper">YOUR BRAND</span>
          </div>
          <div className="flex gap-3">
            <span className="h-1.5 w-8 rounded bg-white/20" />
            <span className="h-1.5 w-8 rounded bg-white/20" />
            <span className="h-1.5 w-8 rounded bg-white/20" />
          </div>
        </div>
        <div className="flex h-24 items-center justify-center rounded-xl bg-[#3b3d52] sm:h-28">
          <Mountain className="h-8 w-8 text-lilac/50" aria-hidden="true" />
        </div>
        <div className="grid grid-cols-3 gap-3">
          {[0, 1, 2].map((i) => (
            <div key={i} className="rounded-xl border border-white/[0.07] bg-ink/50 p-2.5">
              <div className="h-9 rounded-lg bg-lilac/25" />
              <div className="mt-2 h-1.5 w-4/5 rounded bg-white/20" />
              <div className="mt-1.5 h-1.5 w-2/5 rounded bg-lilac/50" />
            </div>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <div className="h-7 w-20 rounded-full bg-lilac/90" />
          <div className="h-2 w-14 rounded bg-white/15" />
        </div>
      </div>
    </div>
  </div>
);
